import { Handler } from '../../../patterns/chainOfResponsibility';
import { FilterHandler } from '../../../patterns/chainOfResponsibility/FilterHandler';
import { SortHandler } from '../../../patterns/chainOfResponsibility/SortHandler';
import { Data } from '../../../patterns/commands';
import { FilterTypes, SortTypes } from '../interfaces';

export class SortAndFilterLaborer {
    private handlers: Handler[] = [];

    public constructor(filterTypes: FilterTypes[], sortTypes: SortTypes[]) {
        this.buildHandlers(filterTypes, sortTypes);
    }

    private buildHandlers(filterTypes: FilterTypes[], sortTypes: SortTypes[]): void {
        let previousHandler: Handler | null = null;

        filterTypes.sort((a, b) => {
            if (['review', 'productType', 'price'].includes(a.type) || ['review', 'productType', 'price'].includes(b.type)) {
                return -1;
            }
            if (!['review', 'productType', 'price'].includes(a.type) || !['review', 'productType', 'price'].includes(b.type)) {
                return 1;
            }
            return 0;
        });

        // Create filter handlers
        filterTypes.forEach((filter) => {
            const handler = new FilterHandler({ filterType: filter.type, keys: filter.keys });
            if (previousHandler) {
                previousHandler.setNext(handler);
            }
            previousHandler = handler;
            this.handlers.push(handler);
        });

        // Create sort handlers
        sortTypes.forEach((sort) => {
            const handler = new SortHandler({ sortType: sort.type, keys: sort.keys });
            if (previousHandler) {
                previousHandler.setNext(handler);
            }
            previousHandler = handler;
            this.handlers.push(handler);
        });
    }

    public processData(data: Data): Data {
        if (this.handlers.length === 0) {
            return data;
        }
        return this.handlers[0].handleRequest(data, []);
    }
}
